/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VendorsRouteImport } from './routes/vendors'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as ErrorsRouteImport } from './routes/errors'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as ProductsProductIdRouteImport } from './routes/products/$productId'

const VendorsRoute = VendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorsRoute = ErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/jobs': typeof JobsRoute
  '/products': typeof ProductsRouteWithChildren
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/vendors': typeof VendorsRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/jobs': typeof JobsRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/vendors': typeof VendorsRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/products': typeof ProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/jobs': typeof JobsRoute
  '/products': typeof ProductsRouteWithChildren
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/vendors': typeof VendorsRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/errors'
    | '/jobs'
    | '/products'
    | '/rules'
    | '/settings'
    | '/vendors'
    | '/products/$productId'
    | '/settings/notifications'
    | '/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/errors'
    | '/jobs'
    | '/rules'
    | '/settings'
    | '/vendors'
    | '/products/$productId'
    | '/settings/notifications'
    | '/products'
  id:
    | '__root__'
    | '/'
    | '/errors'
    | '/jobs'
    | '/products'
    | '/rules'
    | '/settings'
    | '/vendors'
    | '/products/$productId'
    | '/settings/notifications'
    | '/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ErrorsRoute: typeof ErrorsRoute
  JobsRoute: typeof JobsRoute
  ProductsRoute: typeof ProductsRouteWithChildren
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  VendorsRoute: typeof VendorsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vendors': {
      id: '/vendors'
      path: '/vendors'
      fullPath: '/vendors'
      preLoaderRoute: typeof VendorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/errors': {
      id: '/errors'
      path: '/errors'
      fullPath: '/errors'
      preLoaderRoute: typeof ErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof ProductsRoute
    }
  }
}

interface ProductsRouteChildren {
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

interface SettingsRouteChildren {
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsNotificationsRoute: SettingsNotificationsRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ErrorsRoute: ErrorsRoute,
  JobsRoute: JobsRoute,
  ProductsRoute: ProductsRouteWithChildren,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRouteWithChildren,
  VendorsRoute: VendorsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
